<div *ngIf="invoiceCode">
  <app-header></app-header>



  <form *ngIf="orderForm" [formGroup]="orderForm">

    <div *ngIf="!disalbleAll">
      <br /><br />
      <mat-card *ngIf="!showWebIdInfo" class="step-card">
            <mat-card-header>
              <mat-card-title style="text-align: center;">{{"ORDER.PAYMENT.CHANGE_TITLE" | translate : {invoiceCode:this.invoiceCode, amount: this.amountFormatted } }}</mat-card-title>
              <mat-card-subtitle>{{"ORDER.PAYMENT.SUBTITLE" | translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>

              <div [hidden]="false" style="margin-top: 10px;">


              <app-payment-type-selector-list [disabled]="false" [selectedProduct]="null" [wantCardName]="false" [productId]="null"
                                         [allowedPaymentMethods]="allowedPaymentMethods" formControlName="paymentType" required>
              </app-payment-type-selector-list>


            </div>




            </mat-card-content>
            <mat-card-actions align="end">

              <div fxFlex></div>
              <button mat-raised-button color="primary" (click)="changePayment()" *ngIf="true"
                [disabled]="orderForm.invalid">{{"BUTTON.SUBMIT" | translate}}</button>
            </mat-card-actions>
          </mat-card>


    </div>





  </form>
</div>
